module.exports = __webpack_public_path__ + "static/finelite_intro_image-65c88c47b3f9d54d5ffd6e03b39f2c1f.png";